import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AppGuardService } from '../core/interceptors/app-guard.service';

export const routes: Routes = [
  {
    path: '', component: LayoutComponent, children: [
      {
        path: '', redirectTo: 'home/inicio', pathMatch: 'full'
      },
      {
        path: "home", loadChildren: () => import('./home/home.module').then(m => m.HomeModule), canActivate: [AppGuardService]
      },
    ],
  },
  {
    path:'seguridad',loadChildren:()=>import('./seguridad/seguridad.module').then(m=>m.SeguridadModule)
  },
  { path: '**', redirectTo: 'not-404', pathMatch: 'full' },
  { path: '', redirectTo: 'seguridad/login', pathMatch: 'full' },
  { path: 'password', redirectTo: 'seguridad/password', pathMatch: 'full' },
]


@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:false})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
